<template>
  <picture class="main-slider__img-wrap">
    <source
      media="(max-width: 740px)"
      :srcset="getImagePath({ name: promotion.images.mobile['1x'] })"
    >
    <source
      media="(min-width: 800px) and (max-width: 1024px)"
      :srcset="getImagePath({ name: promotion.images.tablet['1x'] })"
    >
    <img
      :loading="getLoadingImage(index)"
      :src="getImagePath({ name: promotion.images.computer['1x'] })"
      :alt="`image-${index}-${promotion.promo_text}`"
    >
  </picture>
</template>

<script setup lang="ts">
import type { PromotionsSlide } from '~/types/promotion'

type Props = {
  promotion: PromotionsSlide
  index: number
}
defineProps<Props>()

const getLoadingImage = (index: number) => {
  return index !== 0 ? 'lazy' : 'eager'
}
</script>

<style lang="scss" scoped>
.main-slider__img-wrap {
  background-color: #fff;
  height: 100%;
  text-align: center;

  @media only screen and (max-width: 740px) {
    display: block;
  }

  img {
    height: 100%;
    width: auto;

    @media only screen and (min-width: 740px) {
      display: block;
    }

    @media only screen and (max-width: 1024px) {
      border-radius: 8px;
      overflow: hidden;
      max-width: 100%;
      height: auto;
      max-height: 100%;
    }
  }
}
</style>
